import React from 'react'
import Aside from './Aside.tsx'
import Card from './Card.tsx'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import { IEcommerceQuestionSchema, EcommerceResponse } from '@aytm/app/swidget/base/questions/Ecommerce/types'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale.ts'
import { countDrawnCards } from '@aytm/app/swidget/base/questions/Ecommerce/utils/hiddenClass.ts'
import style from './Main.module.scss'

interface IMainProps {
  schema: IEcommerceQuestionSchema
  response: EcommerceResponse
  findability: boolean
  onItemSelect: (index: number) => void
  onAddToCart: (qnt: -1 | 1, index: number) => void
  registerCardRef: (id: string, element: HTMLDivElement | null) => void
}

const Main = ({ schema, response, findability, onItemSelect, onAddToCart, registerCardRef }: IMainProps) => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  // the header counts the cards this grid renders: children sit inside their parent's card,
  // none-of-the-above is not a product, and a preview-hidden card is not drawn
  const resultsCount = countDrawnCards(schema.answers.filter(answer => !answer.parent_product && !answer.na))

  return (
    <>
      <div className={`${style.bottom} ${viewport.mobile ? style.bottomMobile : ''}`}>
        {schema.search_condition && (
          <div className={style.resultsText}>{t('questions', 'ec', 'ecommerce', 'results')}</div>
        )}
        <div
          className={style.results}
          style={{ justifyContent: schema.search_condition ? 'space-between' : 'flex-end' }}
        >
          <div
            className={style.condition}
            dangerouslySetInnerHTML={{
              __html: schema.search_condition ? `${schema.search_condition} (${resultsCount})` : ''
            }}
          />
          <div className={style.filters}>
            <EmptyLink color="#111">
              <div className={style.filterItem}>
                <span className={style.text}>{t('questions', 'ec', 'ecommerce', 'hideFilters')}</span>
                <div className={style.filtersIcon} />
              </div>
            </EmptyLink>
            <EmptyLink color="#111">
              <div className={style.filterItem}>
                <span className={style.text}>{t('questions', 'ec', 'ecommerce', 'sortBy')}</span>
                <div className={style.downIcon} />
              </div>
            </EmptyLink>
          </div>
        </div>
      </div>
      <section className={`${style.main} ${viewport.mobile ? style.mainMobile : ''}`}>
        <Aside />
        <div className={style.products}>
          {schema.answers.map((answer, index) =>
            !answer.parent_product && !answer.na ? (
              <Card
                key={index}
                ref={element => registerCardRef(answer.id, element)}
                answer={answer}
                schema={schema}
                quantity={response.answers[index].v}
                findability={findability}
                index={index}
                applyCustomWidth={true}
                onItemSelect={onItemSelect}
                onAddToCart={onAddToCart}
                disabled={'focus' == schema.mode_type && !answer.focused}
              />
            ) : null
          )}
        </div>
      </section>
    </>
  )
}
export default Main
